/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useState } from "react";
import { ExerciseModeEnums, TrackingEnums } from "../configs/enums";
import { handleFetchApi } from "../configs/apiRequest";
import { AAUTH } from "../apis/auth";

const trackingUser = (type) => {
    let currentDate = new Date();
    handleFetchApi(AAUTH.tracking({ data: { type: type, execution_date: currentDate.toISOString().split("T")[0] } }));
};

export const StoreContext = React.createContext(null);

export default ({ children }) => {
    const [me, setMe] = useState();
    // maybe remove in next version
    const [loading, setLoading] = useState(false);
    const [exerciseMode, setExerciseMode] = useState();
    const [exerciseChildren, setExerciseChildren] = useState(new Map());
    const [selectedExercise, setSelectedExercise] = useState();
    const [assignmentExercises, setAssignmentExercises] = useState([]);
    const [displayAds, setDisplayAds] = useState(sessionStorage.getItem("displayAds") ?? 1);
    const [media, setMedia] = useState({});
    const [audioList, setAudioList] = useState();
    const [selectedClass, setSelectedClass] = useState();
    const [breadcrumb, setBreadcrumb] = useState({
        key: "dashboard",
        label: "dashboard",
    });
    const isReading = () =>  window.location.pathname.includes("book");

    const handleTrackingUser = () => {
        if(isReading()) {
            trackingUser(TrackingEnums.READING_BOOK);
        }else {
            trackingUser(TrackingEnums.ONLINE);
        }
    };

    // tracking user every 1 minute
    useEffect(() => {
        if (me) {
           let interval = setInterval(() =>  handleTrackingUser() , 1000 * 60);
            return () => clearInterval(interval);
        }
    }, [me]);

    const stores = {
        loading: loading,
        setLoading: setLoading,
        me: me,
        setMe: setMe,
        exerciseMode: exerciseMode,
        setExerciseMode: setExerciseMode,
        exerciseChildren: exerciseChildren,
        setExerciseChildren: setExerciseChildren,
        selectedExercise: selectedExercise,
        setSelectedExercise: setSelectedExercise,
        audioList: audioList,
        setAudioList: setAudioList,
        assignmentExercises: assignmentExercises,
        setAssignmentExercises: setAssignmentExercises,
        media: media,
        setMedia: setMedia,
        displayAds: displayAds,
        setDisplayAds: setDisplayAds,
        selectedClass: selectedClass,
        setSelectedClass: setSelectedClass,
        setBreadcrumb: setBreadcrumb,
        breadcrumb: breadcrumb,
    };

    return <StoreContext.Provider value={stores}>{children}</StoreContext.Provider>;
};
